import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { hasOptionalConsent, isPrivateAnalyticsPath, OPTIONAL_TRACKING_READY_EVENT } from '@/lib/analyticsConsent';

const MetaPixel = () => {
  const location = useLocation();
  const lastTrackedPath = useRef(null);

  useEffect(() => {
    if (isPrivateAnalyticsPath(location.pathname)) {
      lastTrackedPath.current = location.pathname;
      return;
    }
    const trackPageView = () => {
      if (!hasOptionalConsent() || !window.fbq || lastTrackedPath.current === location.pathname) return;
      window.fbq('track', 'PageView');
      lastTrackedPath.current = location.pathname;
    };
    trackPageView();
    window.addEventListener(OPTIONAL_TRACKING_READY_EVENT, trackPageView);
    return () => window.removeEventListener(OPTIONAL_TRACKING_READY_EVENT, trackPageView);
  }, [location.pathname]);

  return null;
};

export default MetaPixel;
